module.exports = __webpack_public_path__ + "media/img/help_center/Student_Account_Creation_03-9e3e3b90bba3e7b6161d1fdd29277ef3.jpg";